

<template>
	<div class="block sm:flex sm:gap-10 mt-10 sm:mt-20">
		<!-- About profile image -->
		<!-- <div data-aos="fade-right" data-aos-duration="1500" class="w-full sm:w-1/4 mb-7 sm:mb-0">
			<img
				src="@/assets/images/me2.png"
				class="rounded-xl w-96"
				alt=""
			/>
		</div> -->

		<!-- About details -->
		<div data-aos="fade-up" data-aos-duration="1500" class="w-full  text-center sm:text-left mt-5">
			<p 
				v-for="bio in bios"
				:key="bio.id"
				class="font-general-regular mb-4 text-ternary-dark dark:text-ternary-light text-[21px]"
			>
				{{ bio.bio }}
			</p>
			<div data-aos="fade-up" data-aos-duration="1500" data-aos-delay="100">
				<AboutCounter/>
			</div>
		</div>
	</div>
</template>
<script>
import AboutCounter from './AboutCounter';
export default {
	components: {
		AboutCounter,
	},
	data: () => {
		return {
			experienceTitle: 'Years of experience',
			githubTitle: 'Stars on GitHub',
			feedbackTitle: 'Happy Clients',
			projectsTitle: 'Projects completed',
		};
	},
	setup() {
		return {
			bios: [
				{
					id: 1,
					bio:
						"Hi, I'm Wilson, a full stack developer with 2 years of experience in the industry. I have a passion for building innovative web applications and creating seamless user experiences. My skills include proficiency in PHP, JavaScript, Vue, Laravel, as well as expertise in database design, API development, and testing.",
				},
				{
					id: 2,
					bio:
						"I have worked on various projects throughout my career, ranging from small-scale web applications to complex business solutions. My ability to collaborate with cross-functional teams and prioritize tasks allows me to deliver projects on time.",
				},
			],
		};
	},
};
</script>
